import styled from 'styled-components';

export const ErrorContainer = styled.div`
  margin: 16px 0;
`;
